import { createFileRoute } from '@tanstack/react-router'
import { loaderScope } from '~/features/matches/queries'
import { recordingsQuery } from '~/features/video/queries'
import { VideoPage, type VideoSearch } from '~/features/video/VideoPage'

const str = (v: unknown) => (typeof v === 'string' && /^[a-z0-9_-]{1,40}$/i.test(v) ? v : undefined)

export const Route = createFileRoute('/_app/spiele/video')({
  validateSearch: (s: Record<string, unknown>): VideoSearch => {
    const out: VideoSearch = {}
    if (s.tab === 'standards') out.tab = 'standards'
    for (const k of ['art', 'seite', 'ergebnis', 'spieler', 'aufnahme'] as const) {
      const v = str(s[k])
      if (v) out[k] = v
    }
    return out
  },
  loader: async ({ context }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    await context.queryClient.ensureQueryData(recordingsQuery(scope.teamId, scope.season))
  },
  component: function Video() {
    return <VideoPage search={Route.useSearch()} />
  },
})
